import BaseModel from "./base.model";
import PortDetailsModel from "./port-details.model";

export default class SubscriberModel extends BaseModel {

  id = 0;
  first_name = null;
  last_name = null;
  mobile_number = null;
  email_address = null;
  id_type = 'ID';
  id_number = null;
  port_number = false;
  number_to_port = null;
  port_details = new PortDetailsModel();
  user_form = "";

  constructor (data) {
    super();
    if (this.isEmpty(data)) return this;
    this.id = data.id;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.mobile_number = data.mobile_number;
    this.email_address = data.email_address;
    this.id_type = data.id_type;
    this.id_number = data.id_number;
    this.port_number = data.port_number || false;
    this.number_to_port = data.number_to_port;
    this.port_details = new PortDetailsModel(data.port_details)
    this.user_form = data.user_form;
  }  
}
